import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const PolicyIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 1C5.23858 1 3 3.23858 3 6V10C3 12.7614 5.23858 15 8 15C10.7614 15 13 12.7614 13 10V6C13 3.23858 10.7614 1 8 1ZM4.5 6C4.5 4.067 6.067 2.5 8 2.5C9.933 2.5 11.5 4.067 11.5 6V10C11.5 11.933 9.933 13.5 8 13.5C6.067 13.5 4.5 11.933 4.5 10V6ZM8 4C6.89543 4 6 4.89543 6 6V10C6 11.1046 6.89543 12 8 12C9.10457 12 10 11.1046 10 10V6C10 4.89543 9.10457 4 8 4Z"
		></path>
	</svg>
))
